module.exports = __webpack_public_path__ + "img/img-5.a06af25a.png";